export default "__VITE_ASSET__b2c202d1__"